import { Model } from "@vuex-orm/core";
import config from "../configs/TableHeader";

export default class TableHeader extends Model {
  static get entity() {
    return "table_header";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      columns: this.attr(null),
      settings: this.attr(null),
    };
  }

  static get apiConfig() {
    return config;
  }
}
